import { render, staticRenderFns } from "./managementStandardOfFranchiseeZZ.vue?vue&type=template&id=5fbd879c&scoped=true"
import script from "./managementStandardOfFranchiseeZZ.vue?vue&type=script&lang=js"
export * from "./managementStandardOfFranchiseeZZ.vue?vue&type=script&lang=js"
import style0 from "./managementStandardOfFranchiseeZZ.vue?vue&type=style&index=0&id=5fbd879c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd879c",
  null
  
)

export default component.exports